export default "__VITE_ASSET__DHOItDd6__"